import type { ReactNode } from 'react';

import { cx } from '../cx';

export type BadgeTone = 'neutral' | 'gold' | 'terracotta' | 'success' | 'danger';

export function Badge({ tone = 'neutral', children, className }: { tone?: BadgeTone; children: ReactNode; className?: string }) {
  return <span className={cx('ui-badge', tone !== 'neutral' && `ui-badge--${tone}`, className)}>{children}</span>;
}
